var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Download is ready "),_c('span',{staticClass:"text-decoration-underline text-primary c-pointer",on:{"click":_vm.downloadFile}},[_vm._v("click here")]),_vm._v(" to download file ")])
}
var staticRenderFns = []

export { render, staticRenderFns }